import { injectStrict } from './inject';
import { AppDataInjectionKey } from './useAppData';
import { dateNow } from '@shared/date-util';

export function useLicenceCalculations() {
  const { licence } = injectStrict(AppDataInjectionKey);

  function findNextFutureActiveLicence() {
    if (!licence.value) {
      return null;
    }

    const currentLicence = licence.value;

    const now = dateNow();

    return (
      currentLicence.otherLicences
        ?.filter((licence) => new Date(licence.validUntil) > now)
        .sort(
          (a, b) =>
            new Date(a.validFrom).getTime() - new Date(b.validFrom).getTime(),
        )[0] ?? null
    );
  }

  function shouldWarnDueToFutureLicenceHavingLowerStudentLimit() {
    if (!licence.value) {
      return null;
    }

    const currentLicence = licence.value;

    const nextFutureActiveLicence = findNextFutureActiveLicence();

    if (!nextFutureActiveLicence) {
      // Has no future licence
      return false;
    }

    const now = dateNow();

    if (now.getTime() < new Date(nextFutureActiveLicence.validFrom).getTime()) {
      // Future licence has not started yet
      return false;
    }

    // Future licence has started. Check against current licence limit
    return nextFutureActiveLicence.studentsLimit < currentLicence.studentsLimit;
  }

  return {
    findNextFutureActiveLicence,
    shouldWarnDueToFutureLicenceHavingLowerStudentLimit,
  };
}
